module.exports = __webpack_public_path__ + "static/media/Workplace_closing_timeline.22120f9f.svg";